import axios from 'axios';
import { BACKEND_URL } from '../../../utils/index.js';

export const addTrainingSession = async (email, year, calendarWeek, dayOfWeek, session) => {
    return axios.put(`${BACKEND_URL}/trainingSessions/${email}/${year}/${calendarWeek}/${dayOfWeek}`, session);
};

export const deleteTrainingSession = async(email, year, calendarWeek, dayOfWeek) => {
    return axios.delete(`${BACKEND_URL}/trainingSessions/${email}/${year}/${calendarWeek}/${dayOfWeek}`);
};

export const deleteTrainingSessionByID = async(email, trainingSessionID) => {
    return axios.delete(`${BACKEND_URL}/trainingSessions/${email}/${trainingSessionID}`);
};